import { ReactElement } from "react";
import FastIcon from "../../../../assets/icons/accelerometer-fast.svg?react";
import SlowIcon from "../../../../assets/icons/accelerometer-slow.svg?react";
import ClockIcon from "../../../../assets/icons/clock.svg?react";
import UnlockedIcon from "../../../../assets/icons/lock-unlocked.svg?react";
import LockedIcon from "../../../../assets/icons/lock-locked.svg?react";
import ScaleIcon from "../../../../assets/icons/scale.svg?react";
import styles from "./InstrumentLimits.module.scss";
import { asMoney } from "../../util";

interface Item {
  icon: ReactElement;
  label: string;
  value: number | undefined;
}

const Row = ({ items }: { items: Item[] }) => {
  return (
    <div className={`grid grid-cols-2 gap-4 px-4 py-2 w-full ${styles.row}`}>
      {items?.map(({ icon, label, value }, i) => (
        <div key={i} className="flex gap-3 items-center">
          {icon}

          <div className="flex flex-col">
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{asMoney(value)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

interface Props {
  singleRow?: boolean;
  max?: number;
  min?: number;
  opening?: number;
  closing?: number;
  update?: number;
  volume?: number;
  className?: string;
}

const InstrumentLimits = ({
  singleRow,
  max,
  min,
  opening,
  closing,
  update,
  volume,
  className,
}: Props) => {
  const minMaxItems = [
    { icon: <SlowIcon />, label: "Mínimo", value: min },
    { icon: <FastIcon />, label: "Máximo", value: max },
  ];
  const openingClosingItems = [
    { icon: <UnlockedIcon />, label: "Apertura", value: opening },
    { icon: <LockedIcon />, label: "Cierre anterior", value: closing },
  ];

  const updateVolumeItems = [
    { icon: <ClockIcon />, label: "Actualización", value: update },
    { icon: <ScaleIcon />, label: "Volume", value: volume },
  ];

  return singleRow ? (
    <div className={`w-fit ${className}`}>
      <Row
        items={[...updateVolumeItems, ...minMaxItems, ...openingClosingItems]}
      />
    </div>
  ) : (
    <div className={`flex flex-col items-center gap-1 w-fit ${className}`}>
      {min !== undefined && max !== undefined && <Row items={minMaxItems} />}
      {opening !== undefined && closing !== undefined && (
        <Row items={openingClosingItems} />
      )}
      {update !== undefined && volume !== undefined && (
        <Row items={updateVolumeItems} />
      )}
    </div>
  );
};

export default InstrumentLimits;
